// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"9adbce74","276":"97016454","373":"e70ccc51","420":"2f25f624"}[chunkId] + ".chunk.js";
};